import faker from "faker";
import MockPackages from "./packages";
import * as CSSO from "../../../shared/types/csso.types";
import { createContactInfo, createId } from "./shared";

/**
 * createProject
 * @return {*}  {CSSO.Project}
 */
const createProject = (
  projectId?: string,
  packageCount?: number
): CSSO.Project => {
  const id = projectId ?? createId();

  const packagesCount = packageCount ?? Math.trunc(Math.random() * 15 + 1);
  const packages: CSSO.Package[] = MockPackages.getMockPackages(
    packagesCount,
    id
  );

  return {
    id: id,
    projectTitle: faker.company.companyName(),
    siteReadyDate: faker.date.future().toString(),
    mainContact:
      /* istanbul ignore next */ packages.length > 0
        ? packages[0].contacts?.mainContact
        : null,
    projectCoordinator: createContactInfo(),
    packages: packages,
  };
};

/**
 * getMockProjects
 * @param {number} numberOfProjects
 * @return {*}  {Array<CSSO.Project>}
 */
const getMockProjects = (numberOfProjects: number): Array<CSSO.Project> => {
  const projects: Array<CSSO.Project> = [];

  while (projects.length < numberOfProjects) {
    const project = createProject();
    let skip = false;
    for (const existingProject of projects) {
      if (
        existingProject.projectTitle === project.projectTitle ||
        existingProject.id === project.id
      ) {
        skip = true;
        break;
      }
    }
    if (!skip) {
      projects.push(project);
    }
  }
  return projects;
};

/* istanbul ignore next */
const getMockProject = (projectId: string): CSSO.Project => {
  return createProject(projectId);
};

export default { createProject, getMockProjects, getMockProject };
